import React from 'react';

import useParams from 'legacy/common/hooks/useParams';
import Redirect from 'legacy/components/util/Redirect/Redirect';
import { useGetEvent } from 'legacy/events/hooks';
import { EventForHost } from 'legacy/events/types';

import DashboardSkeleton from '../components/DashboardSkeleton';
import EventFinancialsContent from './EventFinancialsContent';
import EventDashboardProvider from '../context';

const NewEventFinancials = () => {
  const params = useParams<{ slug: string; invite: string }>();
  const id = params.slug;

  const { data: event } = useGetEvent(id, {
    shareToken: params.invite
  }) as { data: EventForHost };

  if (!event) {
    // TODO: Add analytics skeleton
    return <DashboardSkeleton />;
  }

  // Make sure only organizers can access the page
  if (event._id && !event.isOrganizer) {
    return <Redirect to="/404" />;
  }

  return (
    <EventDashboardProvider event={event}>
      <EventFinancialsContent />
    </EventDashboardProvider>
  );
};

export default NewEventFinancials;
